import { StepStatus } from "../../enum/common";
import { DepartmentCode, PositionCode } from "../../enum/roles";
import { IUser } from "../../models/Users";

export const canReview = (
  user: IUser,
  status: StepStatus,
  recordDepartment?: DepartmentCode,
): boolean => {
  const department = user.user.department.departmentCode;
  return (
    (department === DepartmentCode.CEO &&
      status === StepStatus.DIRECTOR_PENDING) ||
    (department === DepartmentCode.HR && status === StepStatus.HR_PENDING) ||
    (department === recordDepartment &&
      status === StepStatus.MANAGER_PENDING &&
      user.user.position.positionCode.includes(PositionCode.MANAGER))
  );
};
